import { SET_BURGER_MENU } from "@constants/actionTypes";

const initialState = {
  isOpen: false
};

const burgerMenu = (state = initialState, action) => {
  switch (action.type) {
    case SET_BURGER_MENU:
      return {
        ...state,
        isOpen: action.payload
      };

    default:
      return state;
  }
};

export default burgerMenu;
